// Tłumaczenia aplikacji (vue-i18n, Composition API). Teksty leżą w plikach modułów
// (i18n/<język>/<moduł>.js) pod kluczami opisowymi: `settings.language.title`.
// Brakujący tekst angielski pokazuje się po polsku (fallbackLocale).
import { createI18n } from 'vue-i18n';
import pl from '@/i18n/pl/index.js';
import en from '@/i18n/en/index.js';

// Polskie liczebniki mają trzy formy: „1 zadanie | 2 zadania | 5 zadań" (0 też „zadań").
const polish = (n) => {
    if (n === 1) return 0;
    const ones = n % 10;
    const teens = n % 100;
    return ones >= 2 && ones <= 4 && !(teens >= 12 && teens <= 14) ? 1 : 2;
};

export const i18n = createI18n({
    legacy: false,
    locale: 'pl',
    fallbackLocale: 'pl',
    messages: { pl, en },
    pluralRules: { pl: polish },
    missingWarn: false,
    fallbackWarn: false,
});

// `t` poza komponentami (composables, stałe). Wołać leniwie — w funkcji, computed albo
// getterze — bo język zmienia się w trakcie działania aplikacji.
export const t = (...args) => i18n.global.t(...args);
